import baseApi from "./baseApi";

const getAll = async () => {
    try {
        const response = baseApi.get('/recuperanda',{})
        return response
    } catch(error){
        return error;
    }
}

const create = async (value, number) => {
    try {
        const response = baseApi.post('/recuperanda',{
            name: value,
            cnpj: number
        })
        return response
    } catch(error){
        return error;
    }
}

const deleteRecuperanda = async (id) => {
    try {
        const response = baseApi.delete('/recuperanda/' + id)
        return response
    }catch(error){
        return error
    }
}

const show = async (id) => {
    try {
        const response = baseApi.get('/recuperanda/' + id)
        return response
    }catch(error){
        return error
    }
}


const updateRecuperanda = async (id, nome) => {
    try {
        const response = baseApi.put('/recuperanda/' + id, {
                name: nome
        })
        return response
    }catch(error){
        return error
    }
}

export default {
    getAll,
    create,
    deleteRecuperanda,
    show,
    updateRecuperanda
}